import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./plugins/resize.js";
import "./plugins/element.js";
import "./plugins/dataview.js";
import "./plugins/vue2editor.js";
import "./plugins/download.js";
import "./plugins/exportdocx.js";

// 全局方法
import "./plugins/function.js";

// 持久化存储
import "./plugins/localStorage.js";

// 权限验证
import "./plugins/permission.js";

// 全局样式
import "@/assets/css/normalize.css";

// iconfont图标
import "@/assets/icon/iconfont.css";
import "@/assets/icon/iconfont.js";

// 全局组件
import { CusListUI, CusTableUI, CusDialogUI, CusEditUI } from "@/components";
Vue.component("CusListUI", CusListUI);
Vue.component("CusTableUI", CusTableUI);
Vue.component("CusDialogUI", CusDialogUI);
Vue.component("CusEditUI", CusEditUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
